import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  InitData,
  useLazyDailyRewardControllerGetActiveCampaignStatusQuery,
  useLazyHomeControllerGetInitQuery,
  useLazyHomeControllerGetSelfQuery,
} from '@/store/services/MidleNestApi.service';
import { selectInitData } from '@/store/features';
import { storageLocal } from '@/utils';

export const useInit = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [getInit] = useLazyHomeControllerGetInitQuery();
  const [getSelf] = useLazyHomeControllerGetSelfQuery();
  const [status] = useLazyDailyRewardControllerGetActiveCampaignStatusQuery();
  const data = useSelector(selectInitData) as InitData;

  const initialize = async () => {
    // console.info('initialize');
    const params = new URLSearchParams(location.search);
    if (params.has('ref')) storageLocal.setItem('ref', params.get('ref') || '');
    if (params.has('token')) {
      storageLocal.removeItem('accessToken');
      storageLocal.setItem('refreshToken', params.get('token') || '');
    }
    if (params.has('platform')) storageLocal.setItem('platform', params.get('platform') || 'web');

    setIsLoading(true);
    await Promise.all([
      getInit(),
      getSelf(),
      status(),
      // new Promise((r) => setTimeout(r, 5000)),
    ]);
    setIsLoading(false);
  };

  const getActionTitle = (k?: string): string | undefined =>
    k && data?.providers?.types?.find((i) => i.type === k)?.title?.en;
  const getProviderTitle = (k: string): string =>
    data?.provider?.find((i) => i.value === k)?.label || k?.charAt(0).toUpperCase() + k.slice(1);

  // const getPlatformTitle = (k: string): string =>
  //   data?.platforms?.find((i) => i.value === k)?.label || k?.charAt(0).toUpperCase() + k.slice(1);

  const getPlatforms = () => data?.platforms;
  // data?.providers?.platforms?.map((i) => ({ value: i, label: getPlatformTitle(i) }));
  // => ({ value: i, label: getPlatformTitle(i) }));

  return {
    isLoading,
    initialize,
    data: useMemo(() => ({ ...data }), [data]),
    getActionTitle,
    getPlatforms,
    getProviderTitle,
  };
};
